import React from 'react';
import SectionTitle from './SectionTitle';
import SectionSubTitle from './SectionSubTitle';
import SectionSubContainer from './SectionSubContainer';
import { Link } from '@reach/router';

export default ({ status, shipped_at, shipper, tracking_number, tracking_url, gokada_label_url }) => {
  // console.log("gokada_label_url", gokada_label_url, gokada_label_url?.length > 5 ? "enable":"disable")
  let title = 'Shipping soon';
  let bubble = 'placeholder';
  let subSection = (typeof gokada_label_url === "string" && gokada_label_url?.trim()?.length > 5) && gokada_label_url && shipper !== 'Fez' ? <SectionSubTitle>
    Show <a href={gokada_label_url} target="_blank">this label</a> to rider/shipper
  </SectionSubTitle> : status && (status !== 'delivered' || status !== 'shipped') ? <SectionSubTitle>
    Order <span className="text-muted" style={{color:'blue', cursor:'pointer'}}>shipment processing... </span>
  </SectionSubTitle>:null;

  switch (status) {
    case 'received':
    case 'accepted':
      title = 'Shipping soon';
      bubble = 'placeholder';
      break;

    case 'not-shipped':
      title = 'Not shipped';
      bubble = 'warning';
      subSection = <SectionSubTitle>Check your emails</SectionSubTitle>;
      break;

    case 'shipped':
    case 'not-delivered':
    case 'delivered':
      title = (
        <>
          Shipped (
          <a href={tracking_url} target="_blank">
            track
          </a>
          )
        </>
      );
      bubble = 'checkmark';
      subSection = (
        <>
          <SectionSubTitle>{shipped_at}</SectionSubTitle>
          <SectionSubTitle>
            {shipper}: #{tracking_number}
          </SectionSubTitle>
          {(gokada_label_url && gokada_label_url?.length > 5) && shipper !== 'Fez' ? <SectionSubTitle>
            Show <a href={gokada_label_url} target='_blank'>this label</a> to rider/shipper
          </SectionSubTitle> : status && status !== 'delivered' ? <SectionSubTitle>
            Order <span className="text-muted" style={{color:'skyblue', cursor:'pointer'}}>shipment</span> processing...
          </SectionSubTitle>:null}
        </>
      );
      break;
  }

  return (
    <>
      <SectionTitle bubble={bubble}>&nbsp;</SectionTitle>
      <span className="pt-2">
        <SectionTitle bubble={bubble} hidden={true}>{title}</SectionTitle>
        <SectionSubContainer>{subSection}</SectionSubContainer>
      </span>

    </>
  );
};
